import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Baskets } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { useGetAllBundles } from '@services/useGetAllBundles';

export function BasketsPage() {
    const { allSettings, allBundles } = useData();
    const { request: requestAllBundles } = useGetAllBundles();
    const { t, i18n } = useTranslation();

    const translations = {
        title: t('baskets-component.metatags.title', { marketplace: allSettings?.data?.marketplaceName }),
        description: t('baskets-component.metatags.description', { marketplace: allSettings?.data?.marketplaceName }),
    };

    const seoImage = allBundles?.data?.[0]?.image;

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        image: seoImage?.src
            ? {
                  src: seoImage.src || '',
                  width: seoImage.width,
                  height: seoImage.height,
                  alt: allBundles?.data?.[0]?.name || '',
              }
            : undefined,
        url: SITE_URLS.promoBaskets,
        index: true,
    });

    useEffect(() => {
        requestAllBundles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    const formattedPromoBaskets =
        allBundles?.data?.map((bundle) => ({
            uuid: bundle.uuid || '',
            merchants: bundle.merchants || [],
            name: bundle.name || '',
            image: bundle.image?.src || '',
            price: bundle.price || 0,
            oldPrice: bundle.oldPrice || undefined,
        })) || [];

    return <Baskets promoBasketsHighlights={formattedPromoBaskets} />;
}
